<template>
  <el-dialog
    title="更新交易状态"
    :visible="visible"
    width="420px"
    :destroy-on-close="true"
    :lock-scroll="false"
    append-to-body
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small" @submit.native.prevent>
      <el-form-item label="系统订单">
        <span>{{ order.orderNo }}</span>
      </el-form-item>
      <el-form-item label="交易状态" prop="order_status">
        <el-radio-group v-model="form.order_status">
          <el-radio :label="1">已支付</el-radio>
          <el-radio :label="2">未支付</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VerifyOrderUpdateStatusDialog',
  props: {
    visible: Boolean,
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      form: {
        order_status: 1
      },
      rules: {
        order_status: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.order_status = 1;
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
      }
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const id = Number(this.order && this.order.id);
        if (!id) {
          this.$message.error('订单无效');
          return;
        }
        this.loading = true;
        this.$http.post('/VerifyOrder/updatePayStatus', {
          id,
          order_status: this.form.order_status
        }).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '更新成功');
            this.updateVisible(false);
            this.$emit('done');
            return;
          }
          this.$message.error(res.data.msg || '更新失败');
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    }
  }
};
</script>
